import { tv } from 'tailwind-variants'

import { body2 } from '@ui-kit/core/typography'

export const selectOption = tv({
  slots: {
    container: 'mb-4 mr-2.5 flex flex-row rounded-lg border border-ui-grey-500 p-3',
    text: body2({ bold: true }),
  },
  variants: {
    isChecked: {
      true: {
        container: 'border-brand-lime',
      },
    },
  },
  defaultVariants: {
    isChecked: false,
  },
})

export const multiSelect = tv({
  slots: {
    container: 'flex flex-row flex-wrap',
  },
})
